import _ from 'lodash';

export const validadorContainer = (condicao, mensagem, booking, container ) => {
    let result = true;
        // VALIDADOR
        if (condicao)
        {         
            this.listaMensagens = [mensagem, (container ? `${booking} - ${container}` : `${booking}`)]; 
            result = false; 
        }
   
    return result;    
}


export const valida = (tipoAgenda, terminal, campo, valor, funcaoValidacao=null) => {
    const tipoAgendaEntradaEstufagem = ["ECE"];
    const tipoAgendaEntradaMapaCheio = ["ECCM","ECC", "ECVB", "EUA", "ECDL"];
    
    if (valor===undefined) {
        return true;
    }

    if (campo === 'CdIso' && (valor===null || valor.length===0)) {
            return false;
        }
        if (campo === 'ValPesoMax' && (valor===null || valor.length===0)) {
            return false;
        }
        if (campo === 'ValPesoDoc' && (valor===null || valor.length===0)) {
            return false;
        }
        if (campo === 'CnpjCliente' && (valor===null || valor.length===0)) {
            return false;
    }
    
    return true;
}

export const validaLacre = (tipoAgenda, terminal, valorTipo, valorlacre) => {

    let result  = true
    if (valorlacre===undefined || valorlacre===null || valorlacre.length===0)
    {
        result = !(valorlacre===undefined || valorlacre===null || valorlacre.length===0)
    }
    return result;
}




// WEBPACK FOOTER //
// ./src/modules/principal/containers/Valida.js